var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafeAndHygienic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "safe-and-hygienic_svg__a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469",
    stopOpacity: 0.219
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "safe-and-hygienic_svg__b",
    x1: "0%",
    x2: "100%",
    y1: "79.521%",
    y2: "20.479%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "safe-and-hygienic_svg__c",
    x1: "16.069%",
    x2: "83.931%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F5515F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F0469"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "url(#safe-and-hygienic_svg__a)",
    rx: 21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#safe-and-hygienic_svg__b)",
    d: "M7.793 14.288L4.26 10.742a.71.71 0 01.001-1.003l.603-.6a.711.711 0 011.004 0l2.427 2.438 6.59-6.59a.71.71 0 011.003 0l.602.602a.707.707 0 010 1.003l-7.695 7.696a.71.71 0 01-1.003 0z",
    transform: "translate(13 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#safe-and-hygienic_svg__c)",
    d: "M14.61 9.762c-.674 2.938-2.276 5.563-6.056 8.337a.418.418 0 01-.46 0c-5.731-4.205-6.465-8.061-6.529-13.197a.375.375 0 01.273-.35c2.816-.696 5.14-1.991 6.246-2.681a.496.496 0 01.48 0 23.39 23.39 0 004.267 2.07.489.489 0 00.468-.106L14.134 3c.111-.11.079-.237-.07-.285C11.04 1.744 8.805.165 8.779.145a.783.783 0 00-.909 0C7.838.17 4.597 2.463.634 3.222A.777.777 0 000 3.986C0 9.891.58 14.81 7.88 19.861a.78.78 0 00.888 0c5.611-3.884 7.247-7.69 7.706-11.925.016-.155-.061-.192-.172-.081l-1.431 1.43c-.111.11-.227.324-.262.477z",
    transform: "translate(13 11)"
  }))));
}
export default SvgSafeAndHygienic;